import React, { useEffect } from "react";
import "./App.scss";
import { BrowserRouter, Link } from "react-router-dom";
import Footer from "./components/Footer";
import Header from "./components/Header";
import RouteManager from "./routes/RouteManager";
import AppContextProvider from "./provider/AppContextProvider";
import Loader from "./components/Loader";
import { ApolloProvider } from '@apollo/client/react';
import { BottomNavigation, BottomNavigationAction } from "@mui/material";
import { MsalProvider } from "@azure/msal-react";
import { initializeTelemetry } from "./provider/InitializeTelemetryService";
import { REACT_APP_APP_INSIGHT_CONNECTION_STRING } from "./services/config";
import { IApp } from "./context/model";
import { dxpClient } from "./services/apollo-client";
import { useGlobalContext } from "./provider/GlobalContextProvider";
import { initializeLocalizationService } from "./services/localizationService";
import MobileBottomNav from "./components/MobileBottomNav";

function App({ instance }: IApp) {
    const { updateGLoading } = useGlobalContext();

    initializeLocalizationService().catch(error => {
        console.error('Failed to initialize localization service:', error);
    });
    const accounts = instance.getAllAccounts()[0];
    if (accounts) {
        console.log("accounts present");
    } else {
        updateGLoading(true, "globalLoader");
        updateGLoading(true, "globalHeaderLoading");
    }


    const nameOfUser = sessionStorage.getItem("nameOfUser");
    useEffect(() => {
        if (document.getElementById("adobe-analytics")) return;

        const adobeScript = document.createElement("script");
        adobeScript.id = "adobe-analytics";
        adobeScript.src =
            process.env.REACT_APP_WUCA_ADOBE_ANALYTICS_SCRIPT_URL ?? "";
        adobeScript.async = true;
        // Append the script to the document
        document.body.appendChild(adobeScript);
    }, []);

    const headerProps = {
        logoSrc: "path/to/logo.png",
        userName: nameOfUser || "",
        userRole: "",
        userAvatar: "path/to/avatar.png",
    };
    const browserHistory = require('history').createBrowserHistory();
    React.useEffect(() => {
        initializeTelemetry(REACT_APP_APP_INSIGHT_CONNECTION_STRING, browserHistory);
    }, []);
    return (
        <div className="App" data-testid="appTestId">
            <MsalProvider instance={instance}>

                <BrowserRouter basename={process.env.PUBLIC_URL}>
                    <ApolloProvider client={dxpClient}>

                        <AppContextProvider>
                            <Loader />
                            <div className="app-head-section">
                                <Header header={headerProps} />
                                {/* <Navigation /> */}
                            </div>
                            <div className="app-body-section">
                                <RouteManager />
                                <Footer />
                            </div>
                            <div className="app-mobile-fixed-bottom-section">
                                <MobileBottomNav />
                            </div>
                        </AppContextProvider>
                    </ApolloProvider>

                </BrowserRouter>
            </MsalProvider>
        </div>
    );
}

export default App;
